// extracted by css-extract-rspack-plugin
export default {"rowActionButton":"rowActionButton-Of_EqZ"};